import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Brands from "../helpers/Brands";


export default function BrandCreate() {
    const { appState } = useAppState();
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate()

    const onSubmit = handleSubmit((values) => {
        Brands.create({
            name: values.name,
        }).then(() => {
            navigate('/brands')
        })
    });

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Brands \ New brand</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <form className="" onSubmit={onSubmit}>
                    <div className="space-y-4">
                        <input
                            {...register('name')}
                            placeholder="Name"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />

                        <div className="mt-6 flex items-center justify-end gap-x-6">
                            <Link to="/clients" className="text-sm/6 font-semibold text-gray-900">
                                Cancel
                            </Link>
                            <button
                                type="submit"
                                className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
